import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

type CheckInResultMutationResponse = {
  checkin_result_id: number;
  handled: boolean;
};

export const useCheckInResultMutation = () =>
  useTypedMutation<CheckInResultMutationResponse, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/check_in/result/handle", payload);
    },
    onSuccess: ({ checkin_result_id, handled }) => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.customer_communication?.check_in_results?.length) return;

      const checkInResultIdx = appointment.customer_communication.check_in_results.findIndex(({ id }) => id === checkin_result_id);
      if (checkInResultIdx < 0) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, {
        ...appointment,
        customer_communication: {
          ...appointment.customer_communication,
          check_in_results: appointment.customer_communication.check_in_results.with(checkInResultIdx, {
            ...appointment.customer_communication.check_in_results[checkInResultIdx],
            receptionist_handled: handled
          })
        }
      });
    }
  });
